export default __webpack_public_path__ + "static/media/ImageAndTextCommonForm.db2b6a5a.svg";